.menu-card {
  display: block;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  overflow: hidden;
}

.menu-card__link {
  cursor: pointer;
  display: flex;
  text-decoration: none;
  color: #626469;
  position: relative;
}

.menu-card__picture {
  min-width: 80px;
  height: 80px;
}

:host(:not([dir="rtl"])) .menu-card__picture {
  margin-right: 20px;
}

:host([dir="rtl"]) .menu-card__picture {
  margin-left: 20px;
}

.menu-card__brand-image {
  position: absolute;
  top: 65px;
  width: 60px;
}

:host(:not([dir="rtl"])) .menu-card__brand-image {
  left: 0;
}

:host([dir="rtl"]) .menu-card__brand-image {
  right: 0;
}

.menu-card--small .menu-card__brand-image {
  display: none;
}

.menu-card__text-content {
  margin: 0;
  max-width: calc(100% - 100px);
}

.menu-card--small .menu-card__text-content {
  max-width: calc(100% - 56px);
}

.menu-card__name {
  display: block;
  margin: 0 0 5px;
  font-weight: 700;
  color: #333333;
  max-height: 40px;
  overflow: hidden;
}

.menu-card__link:hover .menu-card__name {
  text-decoration: underline;
}

.menu-card__badge {
  display: block;
  margin-bottom: 8px;
}

.menu-card__description {
  margin: 0;
  padding: 0;
  max-height: 60px;
  overflow: hidden;
}

.menu-card__view-all {
  visibility: hidden;
  max-width: 160px;
}

:host(:not([dir="rtl"])) .menu-card__view-all {
  margin-left: 100px;
}

:host([dir="rtl"]) .menu-card__view-all {
  margin-right: 100px;
}

.menu-card__view-all .menu-card__view-all-link {
  margin-top: 6px;
  margin-bottom: 4px;
}

.menu-card:hover .menu-card__view-all {
  visibility: visible;
}

:host([dir="rtl"]) .menu-card__view-all-icon {
  transform: scaleX(-1)
}

.menu-card__link:hover .menu-card__view-all-icon {
  top: 1px;
}

:host(:not([dir="rtl"])) .menu-card__link:hover .menu-card__view-all-icon {
  right: 5px;
}

:host([dir="rtl"]) .menu-card__link:hover .menu-card__view-all-icon {
  left: 5px;
}

.menu-card--small {
  font-size: 12px;
  line-height: 16px;
}

.menu-card--small .menu-card__picture {
  min-width: 36px;
  height: 36px;
}